export interface IUser {
  LoginID: string;
  UID: string;
  Type: string;
  UserName: string;
  Email: string;
  CreatedAt?: number;
  UpdatedAt?: number;
  OutletCodes: string[];
}

export interface FormUser {
  loginId: string;
  type: string;
  username: string;
  email: string;
  password: string;
  createdAt?: string;
  UpdatedAt?: string;
  outletCode: string[];
}

export class User implements IUser {
  public LoginID: string = '';
  public UID: string = '';
  public Type: string = 'Admin';
  public UserName: string = '';
  public Email: string = '';
  public CreatedAt?: number;
  public UpdatedAt?: number;
  public OutletCodes: string[] = [];

  constructor(user?: IUser) {
    this.LoginID = user ? user.LoginID : '';
    this.UID = user ? user.UID : '';
    this.Type = user ? user.Type : 'Nobody';
    this.UserName = user ? user.UserName : '';
    this.Email = user ? user.Email : '';
    this.OutletCodes = user ? user.OutletCodes : [];
    this.CreatedAt = user ? user.CreatedAt : 0;
    this.UpdatedAt = user ? user.UpdatedAt : 0;
  }
}
